/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `SALES` - Sales
* `COST` - Cost
 */
export type DetailTypeCategoryEnum = typeof DetailTypeCategoryEnum[keyof typeof DetailTypeCategoryEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DetailTypeCategoryEnum = {
  SALES: 'SALES',
  COST: 'COST',
} as const;
